import React from 'react'
import {Row, Modal, Carousel} from 'antd';
import {LeftOutlined, RightOutlined} from '@ant-design/icons'
import {enquireScreen, enquire} from "enquire-js";
import {carouselContent} from '../constants';

let isMobile = false;

enquireScreen((b) => {
   // isMobile = b;
});

enquire.register('screen and (max-width: 750px)', {
    match: function () {
        isMobile = true;
    },
});

/*
const SampleNextArrow = props => {
    const {className, style, onClick} = props
    return (
        <div
            className={className}
            style={{
                ...style,
                color: 'black',
                fontSize: '25px',
                lineHeight: '1.5715'
            }}
            onClick={onClick}
        >
            <RightOutlined/>
        </div>
    )
}

const SamplePrevArrow = props => {
    const {className, style, onClick} = props
    return (
        <div
            className={className}
            style={{
                ...style,
                color: 'black',
                fontSize: '25px',
                lineHeight: '1.5715'
            }}
            onClick={onClick}
        >
            <LeftOutlined/>
        </div>
    )
}

const settings = {
    nextArrow: <SampleNextArrow/>,
    prevArrow: <SamplePrevArrow/>
}
*/

const largeCarouselContent = [carouselContent.slice(0,4), carouselContent.slice(4,8)];

const smallCarouselContent = [carouselContent.slice(0,2), carouselContent.slice(2,4), carouselContent.slice(4,6), carouselContent.slice(6,8)];

class CarouselArrows extends React.Component {

    constructor() {
        super();
        this.state = {
            visible: false,
            current: null
        }
    }

    showImg = (e) => {
        this.setState({current: e.target.src});
    }
    showModal = (e) => {
        this.setState({visible: true});
        this.showImg(e);
    }
    handleCancel = () => {
        this.setState({visible: false});
    }

    render() {
        let {visible, current} = this.state;
        return (
            <>
                <Row justify="center" className=" mb-8">
                    {!isMobile && <Carousel dots={true} className='carousel_parent' style={{minHeight: '120px'}}>

                            {largeCarouselContent.map((currentValue,index) => {
                                 return  <div key={'outer'+index}>
                                <div className="flex justify-center carousel">
                                    {currentValue.map((item,i) => {
                                     return   <div key={'inner'+i} className="flex justify-between flex-col items-center">
                                            <div className='flex flex-col justify-center img_wrapper'>
                                                <img alt='nft' src={item.url}/>
                                            </div>
                                            <div className='nft_text flex flex-col justify-between'>
                                                <div className='text-center nft-title mt-6 uppercase'>
                                                    {item.title}
                                                </div>
                                                <div className='nft-description mt-6 '>
                                                    <a href={item.hash}
                                                       target='_blank' rel='noreferrer'>
                                                        {item.hash}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                })}
                                </div>
                                 </div>
                            })}

                    </Carousel>}
                    {isMobile && <Carousel dots={true} className='carousel_parent' style={{minHeight: '120px'}}>

                        {smallCarouselContent.map((currentValue,index) => {
                            return  <div key={'outer'+index}>
                                <div className="flex justify-center carousel">
                                    {currentValue.map((item,i) => {
                                        return   <div key={'inner'+i} className="flex justify-between flex-col items-center">
                                            <div className='flex flex-col justify-center img_wrapper'>
                                                <img alt='nft' src={item.url}/>
                                            </div>
                                            <div className='nft_text flex flex-col justify-between'>
                                                <div className='text-center nft-title mt-6 uppercase'>
                                                    {item.title}
                                                </div>
                                                <div className='nft-description mt-6 '>
                                                    <a href={item.hash}
                                                       target='_blank' rel='noreferrer'>
                                                        {item.hash}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>
                        })}

                    </Carousel>}

                    <Modal
                        visible={visible}
                        onCancel={this.handleCancel}
                        footer={null}
                        style={{top: '20px'}}
                    >
                        <div className='w-full h-full'>
                            <img alt='nft' src={current}/>
                            <div className="mt-2 bg-white w-full">
                                {
                                    <div>
                                        <div className="flex p-2">
                                            <span>File Name: &nbsp;</span>
                                            <strong>name</strong>
                                        </div>
                                        <div className="flex p-2">
                                            <span>Size: &nbsp;</span>
                                            <strong>size</strong>
                                        </div>
                                        <div className="flex p-2">
                                            <span>Type: &nbsp;</span>
                                            <strong>type</strong>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </Modal>
                </Row>
            </>
        )
    }
}

export default CarouselArrows